import { Part, partProps } from '@/Engine/Wardrobe/Part';
import { defaultShelvesOffsets , defaultShelvesRotation } from '@/Constants/shelves';

export class Shelf extends Part {
    constructor(props: partProps) {
        super({ offsets: [ ...defaultShelvesOffsets ], rotation: [ ...defaultShelvesRotation ], ...props });
    }

}
